const buildCapacityCells = (capacityYear : number, capacityMonth : number) : string[] => {
    const cells = [];
    let currentCapacityYear = capacityYear;
    let currentCapacityMonth = capacityMonth;

    for (let i = 0; i < 7; i++) {
        cells.push(`${currentCapacityYear}-${currentCapacityMonth.toString().padStart(2, '0')}`);

        currentCapacityMonth = currentCapacityMonth === 12 ? 1 : currentCapacityMonth + 1;

        if (currentCapacityMonth === 1) {
            currentCapacityYear++;
        }
    }

    return cells;
};

export default buildCapacityCells;
